export default {
  TRACKING_PAGE: 'tracking-page',
  EMBEDDED_WIDGET: 'embedded-widget',
  EMAIL_TEMPLATE: 'email-template',
}